import { configureStore } from '@reduxjs/toolkit'
import authReducer, { authListenerMiddleware } from './authSlice.js'

export const createAppStore = () =>
  configureStore({
    reducer: {
      auth: authReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).prepend(authListenerMiddleware.middleware),
  })

export const store = createAppStore()

export const setupStore = (preloadedState) =>
  configureStore({
    reducer: {
      auth: authReducer,
    },
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).prepend(authListenerMiddleware.middleware),
  })

export const selectRootState = (state) => state
